import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { isLoaded } from '#src/app/shared/utils/async';

import { useLoginStateAsync } from '../loginState';

import { getViewerPhoneNumber } from './api';
import type { PhoneNumberData } from './api';

export function useCurrentUserPhoneNumber(): UseQueryResult<PhoneNumberData | null> {
	const utilityContext = useUtilityContext();
	const loginStateState = useLoginStateAsync();
	const loginState = isLoaded(loginStateState) ? loginStateState.value : '';

	// TODO: refetch when user changes? e.g. login without page reload
	// Could also be stored in the session context so we don't make the request multiple times
	return useQuery({
		queryKey: ['currentUserPhoneNumber', loginState],
		// tanstack rejects `undefined` query data (treats it as an error), but an unauthenticated
		// viewer or a tolerated field error is a legitimate "no phone number" success state, not a
		// query failure — so the missing-data case is normalized to `null` here.
		queryFn: async () => (await getViewerPhoneNumber(loginState, utilityContext)) ?? null,
	});
}
